// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Config
import config from './config.json';

export const environment = {
	name: config.devEnvironmentName,
	production: false,
	isMockEnabled: false, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	hardCodedToken: '',
	viewer: false,
	edge: false,
	apiUrl: config.devApiUrl,
	hubUrl: config.portalDevHubUrl,
	lvHubUrl: config.portalDevHubUrl,
	syncApiUrl: '',
	lvEnableJobMultiStream: false,
	appInsights: {
		instrumentationKey: '53cb9237-c68a-460c-a281-247d2589ddcd',
	},
	defaultSecret: 'BestRock1234',
	recaptchaKey: '6Lfs7HYiAAAAAHouqpg5vY2XIFBAeEi8Qhis2D4n',
	appVersion: require('../../package.json').version + ' dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
